import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import api from '../api/client';

function SeedNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [lowStockCount, setLowStockCount] = useState(0);

  useEffect(() => {
    api.get(`/api/seeds_notifications`)
      .then(response => response.data)
      .then(data => {
        // Ensure data is an array; if not, set to empty array
        const notificationsArray = Array.isArray(data) ? data : [];
        setNotifications(notificationsArray);
      })
      .catch(error => {
        console.error('Error fetching notifications:', error);
        setNotifications([]); // Set empty array on error
      });

    api.get(`/api/stock-alerts`)
      .then(r => {
        const categories = r.data.categories || [];
        const count = categories.reduce(
          (sum, cat) => sum + cat.groups.reduce((s, g) => s + g.items.length, 0), 0
        );
        setLowStockCount(count);
      })
      .catch(() => setLowStockCount(0));
  }, []);

  const scrollToLowStock = () => {
    document.getElementById('low-stock-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const hasNotifications = notifications.length > 0 || lowStockCount > 0;

  return (
    <div className="seeds-statuses-report-notifications-list">
      {lowStockCount > 0 && (
        <button type="button" className="seeds-statuses-report-attention" onClick={scrollToLowStock}>
          <FontAwesomeIcon icon={faTriangleExclamation} className="seeds-statuses-report-attention-icon" />
          <span>
            Attention: {lowStockCount} {lowStockCount === 1 ? 'item is' : 'items are'} running low on stock
          </span>
          <FontAwesomeIcon icon={faChevronRight} className="seeds-statuses-report-attention-chevron" />
        </button>
      )}

      {notifications.length > 0 ? (
        notifications.map((group, index) => (
          <details key={index}>
            <summary>{group.seedName}</summary>
            <ul>
              {group.items.map((item, i) => (
                <li key={i}>{item.message}</li>
              ))}
            </ul>
          </details>
        ))
      ) : (
        !hasNotifications && <p className="seeds-statuses-report-empty">No notifications available.</p>
      )}
    </div>
  );
}

export default SeedNotifications;
